import { TwcProduct } from '../../../twc-products';

export const WAVE_HEIGHT_PRODUCT_DATA: TwcProduct = {
  id: 'wave-height',
  defaultProductId: 'significantHeightofCombinedWindWavesAndSwell',
  productName: 'Weather-Wave-Height-ECMWF-TWC',
  label: 'Wave Height',
  weatherType: 'WAVE_HEIGHT_FCST',
  description:
    'TWC product (raster, forecast) - ECMWF Global Wave Height Analysis',
  series: 'Forecast',
  timeSlicePeriodInMinutes: 720,
  lodMax: 9,
  protocol: 'WebTile',
  forecastTimeSlicePeriod: 360,
  flightLevelProductIds: {},
  zOrder: 85
};
